import { render, staticRenderFns } from "./SlideLoader.vue?vue&type=template&id=49513334&"
import script from "./SlideLoader.vue?vue&type=script&lang=js&"
export * from "./SlideLoader.vue?vue&type=script&lang=js&"
import style0 from "./SlideLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports